(() => {
  const main = () => {
    // Define the color hexadecimals.
    const purple = 0x4615d5;
    const lightPurple = 0xa392ed;
    const orange = 0xf9681b;

    // Instantiate the Canvas, WebGL Renderer, Scene & Camera.
    const canvas = document.querySelector("#onespan-globe");
    const renderer = new THREE.WebGLRenderer({
      canvas,
      alpha: true,
      powerPreference: "high-performance"
    });

    const scene = new THREE.Scene();
    scene.fog = new THREE.Fog(purple, 25, 80);

    const fov = 30;
    const aspect = window.innerWidth / window.innerHeight;
    const near = 1;
    const far = 100;
    const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
    camera.position.set(-8, 3.5, 40);

    // Instantiate the Globe object.
    const globeObject = new THREE.Object3D({ matrixAutoUpdate: false });

    // Define the Globe vertices.
    const verticesGeometry = new THREE.IcosahedronGeometry(11, 3);
    const verticesMaterial = new THREE.MeshPhongMaterial({
      emissive: lightPurple,
      wireframe: true
    });

    const verticesMesh = new THREE.Mesh(verticesGeometry, verticesMaterial);
    globeObject.add(verticesMesh);

    // Instantiate and position a node.
    function createNode(geometry, material, pos) {
      const node = new THREE.Mesh(geometry, material);

      node.position.x = pos.x;
      node.position.y = pos.y;
      node.position.z = pos.z;

      globeObject.add(node);

      return node;
    }

    // Define the Globe nodes.
    const nodeGeometry = new THREE.SphereBufferGeometry(0.1, 32, 32);
    const nodeMaterial = new THREE.MeshBasicMaterial({ color: lightPurple });

    const nodes = verticesGeometry.vertices.map(function (vertice) {
      return createNode(nodeGeometry, nodeMaterial, vertice);
    });

    scene.add(globeObject);

    // Update the Renderer size.
    function resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const pixelRatio = window.devicePixelRatio;
      const width = (canvas.clientWidth * pixelRatio) | 0;
      const height = (canvas.clientHeight * pixelRatio) | 0;
      const needResize = canvas.width !== width || canvas.height !== height;

      if (needResize) {
        renderer.setSize(width, height, false);
      }

      return needResize;
    }

    let toggleCount = 0;
    const activeMaterial = new THREE.MeshBasicMaterial({ color: orange });

    // Toggle the animation of a random node.
    function toggleNodeAnimation(nodeId = null) {
      if (toggleCount <= nodes.length / 3) {
        const duration = 3;
        const randomNode = nodeId
          ? nodes[nodeId]
          : nodes[Math.floor(Math.random() * nodes.length)];

        if (!randomNode.userData.active) {
          randomNode.material = randomNode.material.clone();
          randomNode.userData.active = true;

          let initialColor = new THREE.Color(
            randomNode.material.color.getHex()
          );
          let activeColor = new THREE.Color(activeMaterial.color.getHex());

          // Animate the node color once.
          TweenMax.to(initialColor, duration, {
            r: activeColor.r,
            g: activeColor.g,
            b: activeColor.b,

            onUpdate: function () {
              randomNode.material.color = initialColor;
            }
          });

          let pulseSphere = createNode(
            nodeGeometry,
            activeMaterial,
            randomNode.position
          );
          pulseSphere.material = pulseSphere.material.clone();
          pulseSphere.material.transparent = true;

          // Animate the pulse scale vector.
          const pulseScale = new THREE.Vector3();
          TweenMax.to(pulseScale, duration, {
            x: 4,
            y: 4,
            z: 4,

            onUpdate: function () {
              pulseSphere.scale.x = pulseScale.x;
              pulseSphere.scale.y = pulseScale.y;
              pulseSphere.scale.z = pulseScale.z;
            }
          }).repeat(-1);

          // Animate the pulse opacity property.
          const opacity = { value: pulseSphere.material.opacity };
          TweenMax.to(opacity, duration, {
            value: 0,

            onUpdate: function () {
              pulseSphere.material.opacity = opacity.value;
            }
          }).repeat(-1);

          toggleCount++;
        } else {
          toggleNodeAnimation();
        }
      }
    }

    // Animation render function.
    let lastTime;
    function render(time) {
      if (resizeRendererToDisplaySize(renderer)) {
        const canvas = renderer.domElement;
        camera.aspect = canvas.clientWidth / canvas.clientHeight;
        camera.updateProjectionMatrix();
      }

      if (!lastTime || time - lastTime >= 350) {
        lastTime = time;
        toggleNodeAnimation();
      }

      globeObject.rotation.x += 0.00035;
      globeObject.rotation.y += 0.00035;

      renderer.render(scene, camera);
      requestAnimationFrame(render);
    }

    requestAnimationFrame(render);

    // Trigger the 44th node animation first because it's one at the front of the globe.
    toggleNodeAnimation(44);
  }

  setTimeout(function () {
    main();
  }, 10)
})();
